<template>
    <div class="d-flex flex-wrap p-0 col-11">

        <form-field :label="getFieldLabel('vetSpecialist')"
            class="col-xs-12 col-sm-5 col-md-4 col-lg-3 p-0 mr-3 mt-3"
            :value="object.vetSpecialist"
            :editable="isEditable('vetSpecialist')"
            :feedback="liveFeedback('vetSpecialist')">
            <template #field>
                    <b-input
                        id="vetSpecialist"
                        class="w-100"
                         v-model="$v.form.vetSpecialist.$model"
                        :state="validateState('vetSpecialist')">
                    </b-input>
            </template>
        </form-field>

        <form-field :label="getFieldLabel('conclusion')"
                    class="col-xs-12 col-sm-12 col-md-6 p-0 mr-3 mt-3"
                    :value="object.conclusion"
                    :editable="isEditable('conclusion')"
                    :feedback="liveFeedback('conclusion')">
            <template #field>
                    <b-form-textarea
                        id="conclusion"
                        class="w-100"
                        v-model="$v.form.conclusion.$model"
                        :state="validateState('conclusion')">
                    </b-form-textarea>
            </template>
        </form-field>

    </div>
</template>

<script>
    import FormField from "../../../../components/Forms/FormField";
    import {ObjectComponentMixin} from "../../../../components/Forms/ObjectComponentMixin";
    import { ExaminationEventAttributes } from "./examination";
    import {AttributeMixin} from "@/pages/AppPages/Events/AttributeMixin";

    export default {
        name: "ExaminationAttributes",
        components: { FormField },
        mixins: [ObjectComponentMixin, AttributeMixin],
        beforeMount() {
            this.objectClass = ExaminationEventAttributes;
            this.initialize();
        },
        mounted() {
            this.onMount();
            this.resetForm();
        },
    }
</script>

<style scoped>

</style>